'use strict';

/**
 * @desc focus on an input
 *
 * @example <input cd-focus-on="expression">
 */

angular
  .module('cdPay.directives')
  .directive('cdFocusOn', ($parse, $timeout) => ({
    restrict: 'A',
    link(scope, elem, attrs) {
      let model = $parse(attrs.cdFocusOn);

      scope.$watch(model, (value) => {
        if (value === true) {
          $timeout(() => elem[0].focus());
        }
      });
    },
  }));
